import {
  Content,
  ButtonsContainer,
  ProductImage,
  ProductInfo,
  Title,
  Description,
  Button,
  ProductImageSectionColor,
  ProductImageSection,
  Options,
  DescriptionProduct,
  ButtonRight,
  ButtonLeft,
  MoreButton
} from "./ContentProduct.style";
import ProductSlider from "../ProductSlider/ProductSlider";
import { VscTriangleLeft, VscTriangleRight } from "react-icons/vsc";
import ProductImageImg from '../../assets/Products/Rekin1empaque 2.png'

const ContentProduct = () => {
  return (
    <Content>
      <ProductImage>
        <ProductImageSection>
          <img
            src={ProductImageImg}
            alt="Product"
          />
          <div></div>
        </ProductImageSection>
        <ProductImageSectionColor />
      </ProductImage>
      <ProductInfo>
        <ProductSlider />
        <div>
        <Title>Angina-Gastreu Rekin® 1</Title>
        <Description>
          <i>Inflamaciones agudas y crónicas</i>
        </Description>
        <Options>
          <p>Indicaciones</p>
          <p>Presentación</p>
          <p>Componentes</p>
        </Options>
        <DescriptionProduct>
          <p>
            Angina tonsillaris, inflamaciones agudas y crónicas, escarlatina,
            otitis media, inflamaciones de las glándulas linfáticas.
          </p>
        </DescriptionProduct>
        </div>
        <MoreButton>
        <ButtonsContainer>
          <ButtonRight>
            <VscTriangleRight />
          </ButtonRight>
          <ButtonLeft>
            <VscTriangleLeft />
          </ButtonLeft>
        </ButtonsContainer>
          <Button>Ver Vademécum</Button>
        </MoreButton>

        
      </ProductInfo>
    </Content>
  );
};

export default ContentProduct;
